import React from "react";

const VisualSettingsPage = () => {
    return (
        <React.Fragment>
            This Page is Under Development right now, will be available in future!
        </React.Fragment>
    )
}
export default VisualSettingsPage